import { render } from "./DefaultDataDesc.vue?vue&type=template&id=5e5d102c"
import script from "./DefaultDataDesc.vue?vue&type=script&lang=js"
export * from "./DefaultDataDesc.vue?vue&type=script&lang=js"

import "./DefaultDataDesc.vue?vue&type=style&index=0&id=5e5d102c&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__